import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  DELIVERY_PRICE_CONFIGURATION_PATH,
  NEW_DELIVERY_PRICE_CONFIGURATION_PATH,
} from '../../../../config/paths';
import {
  clearDeliveryPriceConfigurations,
  getDeliveryPriceConfigurations,
} from '../../../../actions';
import { DELIVERY_PRICE_CONFIGURATION_COLUMNS } from '../../../../config/columns';

export const DeliveryPriceConfigurations = ({
  breadcrumbs,
  materials,
  loading,
  dispatchGetDeliveryPriceConfigurations,
  dispatchClearDeliveryPriceConfigurations,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearDeliveryPriceConfigurations();
    },
    [],
  );

  const data = materials.get('content') || [];
  const pages = materials.get('totalPages') || null;
  const defaultPageSize = materials.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Configuraciones de Precio de Reparto"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_DELIVERY_PRICE_CONFIGURATION_PATH}
      tableStructure={{
        columns: DELIVERY_PRICE_CONFIGURATION_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetDeliveryPriceConfigurations,
        modelPath: DELIVERY_PRICE_CONFIGURATION_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetDeliveryPriceConfigurations: getDeliveryPriceConfigurations,
  dispatchClearDeliveryPriceConfigurations: clearDeliveryPriceConfigurations,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Configuraciones de Precio de Reparto',
      href: DELIVERY_PRICE_CONFIGURATION_PATH,
    },
  ],
  materials: CargoUnit.DeliveryPriceConfiguration.getIn(['all', 'content']),
  loading: CargoUnit.DeliveryPriceConfiguration.getIn(['all', 'loading']),
});

DeliveryPriceConfigurations.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  materials: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetDeliveryPriceConfigurations: PropTypes.func.isRequired,
  dispatchClearDeliveryPriceConfigurations: PropTypes.func.isRequired,
};

DeliveryPriceConfigurations.defaultProps = {
  materials: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliveryPriceConfigurations);
